<template>
  <v-app>
    <v-main class="mb-16">
      <Header
        :backButton="backButton"
        :backFunction="backFunction"
        :title="pageTitle"
        :icon="icon"
        :routeTo="link"
        :routeToTitle="linkTitle"
      />
      <div class="subcontainer">
        <slot></slot>
      </div>
      <Tabs v-if="displayTabs" />
    </v-main>
  </v-app>
</template>

<script>
import Header from "@/layouts/shared/Header";
import Tabs from "@/layouts/shared/Tabs";
import i18n from "@/services/i18n";

export default {
  i18n: i18n,
  components: {
    Header,
    Tabs
  },
  name: "neoparent-layout",
  props: [],

  data() {
    return {
      path: window.location.pathname
    };
  },

  computed: {
    user() {
      return this.$store.getters.user || null;
    },
    patient() {
      return this.user && this.user.patient ? this.user.patient : null;
    },
    patientFirstName() {
      return this.patient && this.patient.firstName ? this.patient.firstName : "NeoParent";
    },
    userLanguage() {
      return this.user && this.user.language ? this.user.language : "nl";
    },
    link() {
      switch (true) {
        case this.path === "/menu":
          return "/logout";
        case this.path === "/settings":
          return "/settings/about";
        case this.path === "/patientselector":
          return "/visitoverview";
        case this.path === "/visit":
          return "/visitoverview";
        case this.path === "/":
          return "";
        default:
          return "/logout";
      }
    },
    linkTitle() {
      switch (true) {
        case this.link === "/visitoverview":
          return this.$t("button.visits");
        case this.link === "/settings/about":
          return this.$t("button.about");
        case this.link === "/logout":
          return this.$t("button.logout");
        case this.path === "/":
          return "";
        default:
          return this.$t("button.logout");
      }
    },
    icon() {
      switch (true) {
        case this.path === "/menu":
          return "sign-out-pink";
        case this.path === "/settings":
          return "question-mark-pink";
        case this.path === "/patientselector":
          return "clock-pink";
        case this.path === "/visit":
          return "clock-pink";
        case this.path === "/":
          return "";
        default:
          return "sign-out-pink";
      }
    },
    pageTitle() {
      switch (true) {
        case this.path === "/menu":
          return this.patientFirstName;
        case this.path === "/hospital":
          return null;
        case this.path === "/create/post":
          return this.$t("general.post.titleFor") + ' ' + this.patientFirstName;
        case this.path.includes("/new-activation"):
          return this.$t("app.settings.general.inviteCode");
        // Settings
        case this.path === "/settings":
          return this.$t("app.settings.title");
        case this.path === "/settings/about":
          return this.$t("app.about.title");
        case this.path === "/settings/access":
          return this.$t("app.grant-access.title");
        case this.path === "/settings/editProfile":
          return this.$t("app.editProfile.title");
        case this.path === "/settings/faq":
          return "FAQ";
        case this.path === "/settings/feedback":
          return this.$t("app.feedback.feedbackTitle");
        case this.path === "/settings/reportProblem":
          return this.$t("app.feedback.title");
        case this.path === "/settings/language":
          if (new URL(window.location).searchParams.get("display") === "1") {
            return this.$t("app.settings.general.display-language");
          } else return this.$t("app.settings.general.address-language");
        // Profile
        case this.path === "/profile/gallery":
          return this.$t("app.gallery.title");
        case this.path === "/profile/evolution":
          return this.$t("app.evolution.title");
        case this.path === "/profile/milestones":
          return this.$t("app.milestone.title");
        case this.path === "/profile/dictionary":
          return this.$t("app.dictionary.title");
        case this.path === "/patientselector":
          return ' ';
        case this.path === "/visit":
          return this.patientFirstName;
        case this.path === "/notifications":
          return this.patientFirstName;
        case this.path === "/visitoverview":
          return this.$t("app.visit.overview");
        case this.path === "/":
          return this.$t("app.visit.overview");
        default:
          return "NeoParent";
      }
    },
    backButton() {
      if (
        this.path === "/menu" ||
        this.path.includes("/new-activation") ||
        this.path.includes("/settings") ||
        this.path === "/hospital" ||
        this.path.includes("/profile") ||
        this.path.includes("/create") ||
        this.path.includes("/visitoverview") ||
        this.path.includes("/patientselector") ||
        this.path.includes("/visit") ||
        this.path.includes("/notifications")
      ) {
        return true;
      }
      return false;
    },
    backFunction() {
      switch (true) {
        default:
          return null;
      }
    },
    displayTabs() {
      return (
        this.path !== "/menu" &&
          !this.path.includes('new-activation') &&
        !this.path.includes("/settings") &&
        !this.path.includes("/profile") &&
        !this.path.includes("/patientselector") &&
        !this.path.includes("/visitoverview") &&
          this.user &&
          this.user.role !== 'n' &&
          this.user.role !== 'a'
      );
    }
  },

  mounted() {
    if (this.userLanguage){
      if (this.userLanguage === "be") {
        this.$store.getters.user.language = "nl-be"
        this.$moment.locale("nl-be")
      } else {
        this.$moment.locale(this.userLanguage)
      }
    }

    const locale = this.userLanguage === "be" ? "nl-be" : this.userLanguage;
    localStorage.setItem("locale", locale)
    this.$i18n.locale = locale
    this.$moment.locale(locale)
  },

  methods: {}
};
</script>

<style lang="scss">
.subcontainer {
  margin: 55px;
}

@media (max-width: 1024px) {
  .subcontainer {
    margin: 52px 8px 68px;
  }
}

@media (hover: none) and (pointer: coarse) {
  .subcontainer {
    margin: 52px 4px 72px;
  }
}

</style>
